import { render, staticRenderFns } from "./PowerFewShotLeft.vue?vue&type=template&id=534379a6&scoped=true"
import script from "./PowerFewShotLeft.vue?vue&type=script&lang=js"
export * from "./PowerFewShotLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534379a6",
  null
  
)

export default component.exports